import React from "react";
import { Button } from "reactstrap";
import { FaLink } from "react-icons/fa";
import { useCrossNicheLinks } from "./hooks/useCrossNicheLinks";

const CrossNicheLinks = ({ agent_name, crossNiche }) => {
    const { formattedLinks } = useCrossNicheLinks({
        crossNiche,
        agent_name,
    });
    return (
        <>
            {formattedLinks?.length > 0 && (
                <div className="my-2">
                    {formattedLinks.map((link, index) => (
                        <div key={`cross-niche-link-${index}`} className="mb-1">
                            <Button
                                color="link"
                                className="d-flex align-items-center m-0 px-0"
                                href={link.href}
                                target="_blank"
                                rel="noopener noreferrer"
                            >
                                <div>
                                    <FaLink
                                        className="me-2"
                                        size="12"
                                        style={{
                                            marginTop: "-4px",
                                        }}
                                    />
                                </div>
                                <div>{link.name}</div>
                            </Button>
                        </div>
                    ))}
                </div>
            )}
        </>
    );
};

export default CrossNicheLinks;
